<template>
  <div class="form-item__container">
    <div class="form-item__left-col">
      <span class="form-item__label">{{ config.label }}</span>
    </div>
    <div class="form-item__right-col">
      <link-selector v-if="showLinkSelector" v-model="$$FormData[config.__key]" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Link',
  mounted() {
    if (!this.$$FormData[this.config.__key]) {
      this.$set(this.$$FormData, this.config.__key, '')
    }
  },
  computed: {
    showLinkSelector() {
      return this.$$FormData[this.config.__key] !== undefined
    }
  }
}
</script>

<style scoped lang="scss">

</style>